import React from "react";
import { Asterisk } from "lucide-react";

/**
 * Slow editorial marquee — one line of brand keywords sliding infinitely.
 * Pure CSS animation (marquee-track), track duplicated to make the loop seamless.
 */
const WORDS = [
  "Roma H24",
  "Soccorso Stradale",
  "Carro Attrezzi",
  "Recupero Incidenti",
  "Batteria Scarica",
  "Traino Moto",
  "Auto in Panne",
  "Provincia di Roma",
  "Sempre Operativi",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="relative bg-white text-navy border-y border-border py-8 md:py-10 overflow-hidden"
    >
      <div className="marquee-track flex whitespace-nowrap gap-14 will-change-transform">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center gap-14 shrink-0" aria-hidden="true">
            {WORDS.map((w, i) => (
              <span
                key={`${k}-${i}`}
                className="flex items-center gap-14 font-display font-black tracking-tight uppercase text-4xl sm:text-6xl lg:text-7xl leading-none"
              >
                <span
                  className={
                    i % 2 === 0 ? "text-navy" : "text-outline-navy"
                  }
                >
                  {w}
                </span>
                <Asterisk className="h-6 w-6 md:h-9 md:w-9 text-brand-orange shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
